import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";

function useWindowResize({ isWindow = false, targetId = null } = {}) {
  const redux_system = useSelector((state) => state.system);
  // 螢幕大小設定
  const [windowScreen, setWindowScreen] = useState({
    width: null,
    height: null,
  });
  const [screenOptions, setScreenOptions] = useState({
    width: null,
    height: null,
  });

  const triggerResize = useCallback(() => {
    const target = document.getElementById(targetId);
    const nextHeight =
      // window.innerHeight === windowScreen.height
      //   ? screenOptions.height
      target?.clientHeight ?? window.innerHeight;

    if (
      window.innerWidth !== windowScreen.width ||
      window.innerHeight !== windowScreen.height
    )
      setWindowScreen({
        width: window.innerWidth,
        height: window.innerHeight,
      });

    setScreenOptions((state) => ({
      ...state,
      width: target ? target.clientWidth : window.innerWidth,
      height: nextHeight,
    }));
  }, [screenOptions.height, targetId, windowScreen.height, windowScreen.width]);

  // 偵測螢幕大小
  useEffect(() => {
    if (!isWindow && !targetId) return;

    window.addEventListener("resize", triggerResize);

    triggerResize();

    return () => {
      window.removeEventListener("resize", triggerResize);
    };
  }, [isWindow, targetId, triggerResize]);

  useEffect(() => {
    if (!isWindow && !targetId) return;

    const timer = setTimeout(() => {
      triggerResize();
    }, 200);

    return () => clearTimeout(timer);
  }, [isWindow, redux_system.backLayout.isShrink, targetId, triggerResize]);

  return { screenOptions, triggerResize };
}

export default useWindowResize;
